import { authenticatedFetch } from "./auth.api";

const BASE_URL = process.env.REACT_APP_ZVB_URL ;

// API call to fetch all quote requests
export const fetchQuoteRequests = async (date) => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/quoterequests`
    );


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while fetching Quote Requests", error);
    return null;
  }
};

// API call to mark quote request Copmpleted
export const markQuoteRequestCompleted = async (quoteId) => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/quoterequests/${quoteId}/complete`, {
      method: "POST",
      body: JSON.stringify({ status: "completed" }),
    });


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while trying to mark quote request completed", error);
    return null;
  }
};

// API call to mark quote request Copmpleted
export const markQuoteRequestInspection = async (quoteId) => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/quoterequests/${quoteId}/requestinspection`, {
      method: "POST",
      body: JSON.stringify({ status: "requested inspection" }),
    });


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while trying to mark quote request completed", error);
    return null;
  }
};

// API call to send the quote
export const sendQuote = async (payload) => {
    try {

        const formData = new FormData();

        formData.append("quoteId", payload.quoteId);

        if (payload.message) {
            formData.append("message", payload.message);
        }

        if (payload.file) {
            formData.append("file", payload.file);
        }

        const response = await authenticatedFetch(`${BASE_URL}/quoterequests/send`, {
            method: "POST",
            body: formData,
        });

        return await response.json();

    } catch (error) {
        console.error("Send Quote Error:", error);
        return null;
    }
};